module.exports = __webpack_public_path__ + "static/media/arrow-left.3447d234.svg";